/**
 * ModeSelector v0.3
 *
 * 「和訳 / 要約 / 通訳」の3タブ。
 * クリックすると onChange に新しいMode値が通知される。
 */

import type { Mode } from '../types';

import styles from './ModeSelector.module.css';

export interface ModeSelectorProps {
  mode: Mode;
  onChange: (mode: Mode) => void;
}

const MODES: ReadonlyArray<{ value: Mode; label: string }> = [
  { value: 'translate', label: '和訳' },
  { value: 'summarize', label: '要約' },
  { value: 'interpret', label: '通訳' },
];

export function ModeSelector({ mode, onChange }: ModeSelectorProps) {
  return (
    <div className={styles.root} role="radiogroup" aria-label="認識モード">
      {MODES.map(({ value, label }) => {
        const isActive = mode === value;
        return (
          <button
            key={value}
            type="button"
            role="radio"
            aria-checked={isActive}
            className={`${styles.button} ${isActive ? styles.buttonActive : ''}`}
            onClick={() => onChange(value)}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
